import { useState, useEffect } from 'react';
import { Statistics } from '../types/statistics';
import { api } from '../utils/api';

type ConversionResult = 'success' | 'error';

export function useStatistics() {
  const [statistics, setStatistics] = useState<Statistics | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStatistics = async () => {
      try {
        const data = await api.getStatistics();
        setStatistics(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching statistics:', err);
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setIsLoading(false);
      }
    };

    // Fetch immediately
    fetchStatistics();

    // Then fetch every 30 seconds
    const interval = setInterval(fetchStatistics, 30000);

    return () => clearInterval(interval);
  }, []);

  const registerConversion = async (_result: ConversionResult) => {
    // Statistics are automatically updated by the backend during conversion
    // This method is kept for compatibility but doesn't need to do anything
    console.log('Statistics are automatically updated by the backend');
  };

  return { statistics, isLoading, error, registerConversion };
}
